var placeholder = require('../../data/placeHolderCopy');

module.exports = {
  content: function content() {
    return {
      // Instead of exposing the mixin directly, we're retuning  a function
      // to be initialized the declaring the mixin. This is to avoid
      // inmediate start of code.
      labels: window.dealerLocator && window.dealerLocator.labels
        ? window.dealerLocator.labels : placeholder.labels,
      ctas: window.dealerLocator && window.dealerLocator.CTAs
        ? window.dealerLocator.CTAs : placeholder.CTAs,
      badges: window.dealerLocator && window.dealerLocator.badges
        ? window.dealerLocator.badges : placeholder.badges,
      departments: window.dealerLocator && window.dealerLocator.departments
        ? window.dealerLocator.departments : placeholder.departments,
      filters: window.dealerLocator && window.dealerLocator.filters
        ? window.dealerLocator.filters : placeholder.filters,
      states: window.dealerLocator && window.dealerLocator.states
        ? window.dealerLocator.states : placeholder.states,
      filterDistance: window.dealerLocator && window.dealerLocator.filterDistance
        ? window.dealerLocator.filterDistance : placeholder.filterDistance,
    };
  },
};
